import { arrayOf, shape, string } from "prop-types";
import { useEffect, useState } from "react";

import qs from "query-string";

const propTypes = {
  searches: arrayOf(
    shape({
      title: string,
      beforeTerm: string,
      afterTerm: string,
      defaultTextBefore: string,
      defaultTextAfter: string,
      href: string,
    }),
  ),
};

const AuxiliarySearch = (props) => {
  //console.log(props);
  const { searches } = props;

  const [query, setQuery] = useState(qs.parse(window.location.search).q || "");

  useEffect(() => {
    const autoCompleteEl = document.querySelector(".gssb_e");
    const searchInputEl = document.querySelector("input.gsc-input");

    if (searchInputEl) {
      searchInputEl.addEventListener("keyup", (e) => {
        setQuery(e.target.value);
      });

      searchInputEl.addEventListener("paste", (e) => {
        setQuery(e.target.value);
      });
    }

    if (autoCompleteEl) {
      autoCompleteEl.addEventListener("click", (e) =>
        setQuery(e.target.innerText),
      );
    }
  }, []);

  return (
    <div className="auxiliary-search">
      {searches.map((search, i) => (
        <div key={i} className="auxiliary-search__search-box">
          <div className="auxiliary-search__eyebrow">{search.title}</div>
          {query !== "" ? (
            <>
              <span>{search.beforeTerm}</span>
              <span className="auxiliary-search__query">
                {" "}
                <a
                  className="auxiliary-search__link"
                  href={search.href + query}
                >
                  '{query}'
                </a>{" "}
              </span>
              <span>{search.afterTerm}</span>
            </>
          ) : (
            <div>
              {search.defaultTextBefore}{" "}
              <a href={search.href}>{search.title}</a> {search.defaultTextAfter}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

AuxiliarySearch.propTypes = propTypes;
export default AuxiliarySearch;
